import { all, fork, put, takeEvery } from "redux-saga/effects";
import * as api from "../../api";

import { FETCH_COMMITS } from "../actions";

import { fetchCommitsSuccess, fetchCommitsError } from "./actions";

function* fetchCommitsForBranch({ payload }) {
  const req = yield api.getData(`/git/commits?branch=${payload.branch}`);

  if (req.status === 200) {
    const data = yield req.json();
    yield put(fetchCommitsSuccess(data));
  } else {
    yield put(fetchCommitsError(req.error.message));
  }
}

function* watchFetchCommits() {
  return yield takeEvery(FETCH_COMMITS, fetchCommitsForBranch);
}

export default function* rootSaga() {
  yield all([fork(watchFetchCommits)]);
}
